export const ComponentAddressBar = {
  extends: ['DropdownParentFocus'],
  tag: 'search',
  position: 'relative',
  theme: 'quinary',
  round: 'radiusPill',
  minWidth: 'D3',
  margin: '-V - - -',
  Form: {
    flow: 'x',
    align: 'center',
    gap: 'X',
    margin: '0',
    attr: {
      novalidate: true
    },
    onSubmit: (ev, el, s) => {
      ev.preventDefault()
    },
    Icon: {
      fontSize: 'Z1',
      margin: '- -B2 - A',
      name: 'search'
    },
    Input: {
      autofocus: 'autofocus',
      flex: 1,
      round: '0',
      placeholder: (el) => el.call('polyglot', 'editor.addressBar.searchPlaceholder'),
      padding: 'Y1 B2 Y1 B2',
      theme: 'transparent',
      // A typed value takes the brand value ink; the transparent theme's own
      // ink is a 65% alpha, one tone with the placeholder hint in light.
      color: 'title',
      outline: 'none',
      name: 'url',
      required: true,
      type: 'text',
      appearance: 'none',
      ':focus-visible': {
        outline: 'none'
      },
      '::-webkit-search-cancel-button': {
        display: 'none'
      },
      '::placeholder': {
        color: 'placeholder'
      },
      onInput: (ev, el, s) => {
        s.update({
          searchTerm: el.node.value
        })
      }
    }
  },
  CanvasSearchDropdown: {
    Items: {
      childProps: {
        Flex_Buttons: null,
        onClick: (ev, el, s) => {
          const key = s.key
          const type = s.type
          s.parent.update({
            type,
            key
          })
        }
      }
    },
    // Wrapper first, menu body LAST — the §7.7 MenuPanel surface must win the
    // merge over the brand Dropdown's legacy common-box chrome. (The list slot
    // re-keyed ListInDropdown → Items with the §7.7 re-chassis.)
    extends: ['Dropdown', 'CanvasSearchDropdown'],
    width: '100%',
    left: '0',
    typesToIndex: ['components', 'pages']
  }
}
